/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import L from "./Lang"
import BaseCom from "./BaseCom";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";

class Home extends BaseCom {
    async componentDidMount() {
        await this.getSettings();
        let user = await this.getLoginAsync();
        setTimeout(() => {
            if (this.state.MODEL === 'MNF') {
                if (user.roles.indexOf('consumer') !== -1)
                    this.props.navigate('/shop/category');
                else if (user.roles.indexOf('admin') !== -1)
                    this.props.navigate('/dashboard');
                else
                    this.props.navigate('/inventory');
            }
            else
                this.props.navigate('/dashboard');
        }, 100);
    }
    render() {
        return null;
    }
}

export default withParamsAndNavigate(Home);